import { Alert, Button, Container, Group, Stack, Text, Title } from "@mantine/core";
import FileUploaderSimple from "./FileUploaderSimple";
import { useState } from "react";
import { uploadFile } from "../api";
import { useLocation } from "wouter";
import { IconDownload, IconInfoCircle } from "@tabler/icons-react";
import { useStore } from "../store";
import { useMarketplaces } from "../_Shared/useMarketplaces";
import MerchantHelp from "../Help/MerchantHelp";

function UploadPage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [, setLocation] = useLocation();
  const tenantProfile = useStore((state) => state.tenantProfile);
  const { marketplaces } = useMarketplaces();
  const partnerMpId = tenantProfile?.partnerMarketplaceId;
  const marketplaceName =
    marketplaces?.find((m) => m.value === partnerMpId)?.label ||
    (partnerMpId ? "B&Q Marketplace" : null);

  return (
    <Container size="sm">
      <Stack>
        <div>
          <Title order={2}>
            {marketplaceName
              ? `Upload for ${marketplaceName}`
              : "Upload product data"}
          </Title>
          <Text c="dimmed" mt={4}>
            Drop a CSV or Excel file from your webshop, eBay, a supplier, or
            Amazon ASINs. We detect the file type from the file itself.
          </Text>
        </div>

        <FileUploaderSimple onFileSelected={setSelectedFile} />

        <Alert color="gray" variant="light" icon={<IconInfoCircle size={16} />}>
          Have Amazon ASINs? Download the Excel template, fill it in, and upload
          it here. We will look up the listings for you.
          <Group justify="flex-end">
            <Button
              component="a"
              variant="white"
              leftSection={<IconDownload size={14} />}
              href="/templates/Optivise ASIN Upload Template.xlsx"
              download
              mt="sm"
            >
              Download ASIN template
            </Button>
          </Group>
        </Alert>

        <Button
          loading={isUploading}
          onClick={() => {
            setIsUploading(true);
            uploadFile(selectedFile)
              .then((created) => {
                setLocation(created?.id ? `/imports/${created.id}` : "/imports");
              })
              .catch(() => {})
              .finally(() => {
                setIsUploading(false);
              });
          }}
          disabled={!selectedFile}
        >
          Upload
        </Button>
        <MerchantHelp marketplaceName={marketplaceName} />
      </Stack>
    </Container>
  );
}

export default UploadPage;
